import type { ReactNode } from 'react'

import { type TypographyProps } from '@material-ui/system'

import { StatusLabelStyled } from './styles/StatusLabelStyled'
import { Icon, type IconTypes } from '../Icon'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const StatusLabelStatuses = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  INACTIVE: 'inactive',
  NEW: 'new',
} as const

export type StatusLabelStatus = Enum<typeof StatusLabelStatuses>

export interface IStatusLabelProps extends Pick<TypographyProps, 'fontSize'> {
  /**
   * Unique identifier for analytics tracking of status label interactions.
   */
  analyticsId?: string
  type: StatusLabelStatus
  text: string
  icon?: IconTypes
  iconComponent?: ReactNode
  paddingSize?: 'small' | 'medium'
  'aria-label'?: string
}

/**
 * @deprecated Please use `<StatusBadge />` or `<InfoBadge />` instead.
 */
export const StatusLabel = ({
  analyticsId,
  type,
  text,
  icon,
  iconComponent,
  paddingSize = 'medium',
  fontSize = 14,
  'aria-label': ariaLabel,
}: IStatusLabelProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)
  const hasIcon = !!icon || !!iconComponent

  return (
    <StatusLabelStyled
      type={type}
      fontSize={fontSize}
      paddingSize={paddingSize}
      hasIcon={hasIcon}
      aria-label={ariaLabel}
      {...analyticsProps}
    >
      {!!iconComponent && iconComponent}

      {!!icon && <Icon icon={icon} />}

      <span>{text}</span>
    </StatusLabelStyled>
  )
}
